import OrdersAPI from 'dashboard/api/pipelines/orders';

const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getOrders: _state => _state.records,
  getMeta: _state => _state.meta,
  getOrder: _state => id => _state.records.find(o => o.id === id) || null,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetchOrders: async ({ commit }, { accountId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await OrdersAPI.getOrders(accountId, params);
      const payload  = response.data?.data?.payload || [];
      const meta     = response.data?.data?.meta || {};
      commit('SET_ORDERS', { orders: payload, meta });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  updateOrder: async ({ commit }, { accountId, orderId, data }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await OrdersAPI.updateOrder(accountId, orderId, data);
      const order    = response.data?.data;
      if (order) commit('UPDATE_ORDER', order);
      return order;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },

  SET_ORDERS(_state, { orders, meta }) {
    _state.records = Array.isArray(orders) ? orders : [];
    _state.meta    = meta;
  },

  UPDATE_ORDER(_state, order) {
    const index = _state.records.findIndex(r => r.id === order.id);
    if (index !== -1) {
      _state.records[index] = { ..._state.records[index], ...order };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
